export const videoConstraints = {
  width: 1280,
  height: 720,
  facingMode: "user",
  deviceId: "",
};
